<template>
  <div class="u-pb5 u-pr5" v-loading="loading" v-if="deployments && deployments.length > 0">
    <h2 class="u-pl5">Kubernetes deployments:</h2>
    <el-table class="u-ml5 u-mr5"  :data="deployments">
      <el-table-column
          label="Operations"
          width="240">
        <template slot-scope="scope">
          <el-button @click="willLoadLogs(scope.row)">
            Logs
          </el-button>
          <a :href="scope.row.aws_href" target="_blank">
            <el-button>
              See on AWS
            </el-button>
          </a>

        </template>

      </el-table-column>
      <el-table-column
          prop="status"
          label="Status"
          width="180">
        <template slot-scope="scope">
          <ba-status-label :build="scope.row"></ba-status-label>
        </template>
      </el-table-column>

      <el-table-column
          prop="queued_at"
          label="Queued At"
      >
        <template slot-scope="scope">
          <div :title="'Time is local. \n UTC:' + scope.row.queued_at">{{scope.row.queued_at |
            moment('YYYY-MM-DD HH:mm')}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Completed">
        <template slot-scope="scope">
          <ba-build-completed-date :at="scope.row.completed_at"></ba-build-completed-date>
        </template>
      </el-table-column>

    </el-table>
    <ba-build-log class="u-ml5" v-if="selectedDeployment"
                  mode="deployment"
                  :build-id="selectedDeployment"
                  :load-immediately="true"
    ></ba-build-log>
  </div>
  <div v-else class="u-p5">No deployments yet...</div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'
  import BaBuildLog from '@/modules/builds/build-log.component'

  export default {
    name: 'ba-desktop-build-deployments',
    components: { BaBuildLog },
    props: ['buildId'],
    data () {
      axios.get(config.url + '/desktop-build/'+ this.buildId + '/deployments/', {})
        .then((response) => {
          this.deployments = response.data
          this.loading = false
        })

      return {
        loading: true,
        deployments: [],
        selectedDeployment: null,
      }
    },
    methods: {
      willLoadLogs (deploymentRef) {
        this.selectedDeployment = deploymentRef.id
      },
    },
  }
</script>

<style scoped>

</style>